<template>
  <PopupWrapper :ref="(el: any) => popup = el" class="wheel-of-fortune" :hide-close-btn="true">
    <div class="d-flex flex-column">
      <div v-if="state.step >= 0">
      <div>
        <h1>{{ $t('wheel_of_fortune_title') }}</h1>
        <span class="day-description">{{ $t('wheel_of_fortune_day_number', {num: currentDay?.num ?? 1, count: 7}) }}</span>
      </div>
      <div id="daily-rewards" class="daily-rewards">
        <div v-for="(days, index) in rows" :key="index"  class="rewards-row">
          <div v-for="day in days" :key="day.num" :class="[day.num === 7 ? 'last-day' : '', day.isClaimed ? 'claimed' : '', day.isCurrent ? 'active' : '']" class="reward-card">
            <template v-if="day.num === 7">
              <img class="coin coin--large" src="/img/coins/gold_coin.svg" alt="coin">
              <div class="content">
                <div class="badges">
                  <div class="badge">
                    <img src="/img/icons/star.svg">
                    <span v-if="day.isClaimed" class="text-capitalize-first">{{ $t('claimed') }}</span>
                    <span v-else class="text-capitalize-first">{{ $t('day_number', {num: day.num}) }}</span>
                  </div>
                </div>
                <div class="rewards">
                  <div>
                    <div class="reward-value">+{{numberFormatter.formatNumber(day.percent)}}%</div>
                    <div class="reward-label">Free coins</div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="badge">
                <img src="/img/icons/star.svg">
                <span v-if="day.isClaimed" class="text-capitalize-first">{{ $t('claimed') }}</span>
                <span v-else class="text-capitalize-first">{{ $t('day_number', {num: day.num}) }}</span>
              </div>
              <img class="coin" src="/img/coins/gold_coin.svg" alt="coin">
              <div class="rewards">
                <div>
                  <div class="reward-value">+{{numberFormatter.formatNumber(day.percent)}}%</div>
                  <div class="reward-label">Free coins</div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="text-center">
          <div class="reset-notice">{{ $t('day_reset_notice') }}</div>
          <div>
            <button @click.prevent="showReel" :disabled="state.step !== 0" class="btn btn-primary btn-spin mb-2"><span class="text-capitalize-first">{{$t('spin_reel')}}</span></button>
          </div>
        </div>
      </div>
      </div>
      <div v-if="state.step >= 0" ref="wheelSectionRef" class="wheel-section-appear">
        <div class="d-flex justify-content-center position-relative">
          <div class="marker"></div>
        </div>
        <div class="wheel d-flex justify-content-center">
          <canvas :ref="(el:any) => canvasRef = el" id="wheel" width="500" height="500"></canvas>
        </div>
      </div>
      <div v-if="state.step >= 2" class="bonuses-section-appear">
      <div class="d-flex flex-column align-items-center">
        <h2>{{$t('wheel_of_fortune_total_bonus', {coins: numberFormatter.formatNumber(totalBonus?.amount)})}}</h2>
        <div class="bonuses">
          <div class="bonus-row">
            <div class="bonus-result">
              <div class="title">{{$t('bonuses.spin_bonus')}}</div>
              <div class="sub">{{ $t(`league.${wheelBonus?.league}`) }}</div>
              <div class="coins">
                <img src="/img/coins/gold_coin.svg">
                <span>{{numberFormatter.formatNumber(wheelBonus?.winSum.amount)}}</span>
              </div>
              <div class="description">
                The higher your league, the bigger your bonuses on the wheel
              </div>
            </div>
            <div class="bonus-result">
              <div class="title">{{$t('bonuses.return_bonus')}}</div>
              <div v-if="returnBonus?.loginsCount === 1" class="sub">{{ $t(`bonuses.return_bonus_day`, {days: returnBonus?.loginsCount, percent: returnBonus?.percent}) }}</div>
              <div v-else class="sub">{{ $t(`bonuses.return_bonus_days`, {days: returnBonus?.loginsCount, percent: returnBonus?.percent}) }}</div>
              <div class="coins">
                <img src="/img/coins/gold_coin.svg">
                <span>{{numberFormatter.formatNumber(returnBonus?.winSum.amount)}}</span>
              </div>
              <div class="description">
                Earn extra bonus for every day in a row you come back to play. Max bonus is {{ returnBonus.maxPercent }}%
              </div>
            </div>
          </div>
          <div class="bonus-row">
            <div class="bonus-result">
              <div class="title">{{$t('bonuses.play_bonus')}}</div>
              <div class="sub">
                <span v-if="!playBonus?.hasBonus">You didn’t play</span>
                <span v-else>+{{ playBonus?.percent }}%</span>
              </div>
              <div class="coins">
                <img src="/img/coins/gold_coin.svg">
                <span>{{numberFormatter.formatNumber(playBonus?.winSum.amount)}}</span>
              </div>
              <div class="description">
                Earn extra bonus every day for spinning at least 10 times.
              </div>
            </div>
            <div class="bonus-result">
              <div class="title">{{$t('bonuses.purchase_bonus')}}</div>
              <div class="sub">
                <span v-if="!purchaseBonus?.hasBonus">You didn’t purchase</span>
                <span v-else>{{ purchaseBonus?.multiplier }}</span>
              </div>
              <div class="coins">
                <img src="/img/coins/gold_coin.svg">
                <span>{{numberFormatter.formatNumber(purchaseBonus?.winSum.amount)}}</span>
              </div>
              <div class="description">
                Earn an extra bonus every day for 3 days whenever you stock up on coins in our store.
              </div>
            </div>
          </div>
        </div>
        <div>
          <button ref="collectBtnRef" @click="claim" class="btn btn-primary mt-2">{{$t('collect_bonus')}}</button>
        </div>
      </div>
      </div>
    </div>
  </PopupWrapper>
</template>
<style scoped>
.wheel-of-fortune {
  .btn-spin {
    padding-left: var(--margin-xxl);
    padding-right: var(--margin-xxl);
  }


  .marker {
    position: absolute;
    inset: 0 50% 0 50%;
    pointer-events: none;
    z-index: 2;
    top: 2px;
    bottom: 2px;

    &::before {
      content: '';
      position: absolute;
      left: 50%; transform: translateX(-50%);
      border: 18px solid transparent;
      border-right-width: 12px;
      border-left-width: 12px;
    }
    &::before { top: 0;    border-top-color: var(--primary-color); }
  }
}

@keyframes wheelFadeIn {
  from { opacity: 0; transform: translateY(24px); }
  to   { opacity: 1; transform: translateY(0); }
}

.wheel-section-appear {
  animation: wheelFadeIn 0.4s ease-out both;
}

.bonuses-section-appear {
  animation: wheelFadeIn 0.5s ease-out both;
}

#wheel {
  width: 100%;
  height: 100%;
  max-width: 400px;
  max-height: 400px;
}

.bonuses {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: var(--margin-xs);

  .bonus-row {
    display: flex;
    gap: var(--margin-xs);

    .bonus-result {
      border-radius: var(--border-radius);
      padding-top: var(--margin-normal);
      padding-bottom: var(--margin-normal);
      background: var(--header-bg);
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: var(--margin-xxs);

      .title {
        font-weight: 600;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: 0%;
        text-align: center;
      }

      .sub {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.5%;
        text-align: center;
        color: #FFFFFF80;

      }

      .description {
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0%;
        text-align: center;
        color: #FFFFFF80;
        padding-right: var(--margin-normal);
        padding-left: var(--margin-normal);
      }

      .coins {
        display: flex;
        gap: var(--margin-xs);
        justify-content: center;
        align-items: center;
        img {
          width: 24px;
          height: 24px;
        }
        span {
          font-family: "Space Grotesk", sans-serif;
          font-weight: 700;
          font-size: 20px;
          line-height: 28px;
          color: #F7B00C;

        }
      }

    }
  }
}
</style>
<script setup lang="ts">
import PopupWrapper from "@/components/PopupWrapper.vue";
import {computed, ref, watch, nextTick} from "vue";
import {reactive} from "@vue/reactivity";
import DailyBonusStateDTO from "@/models/DailyBonusStateDTO";
import {numberFormatter} from "@/service/NumberFormatter";
import {api} from "@/service/APIClient";
import {useStore} from "vuex";

interface DayDTO {
  num: number,
  percent?: number
  isClaimed: boolean,
  isCurrent: boolean,
}

const state = reactive({
  currentAngle: 0 as number,
  bonusState: null as DailyBonusStateDTO|null,
  spinning: false as boolean,
  step: 0
})

const show = (bonusState: DailyBonusStateDTO) => {
  state.bonusState = bonusState
  popup.value?.show()
}

const hide = () => {
  popup.value?.hide()
}

defineExpose({ show, hide })

const rows = computed(() => {
  let items = [];
  for (const rows of [[1,2,3],[4,5,6],[7]]) {
    let dayItems = [];
    for (const dayNum of rows) {
      dayItems.push({
        num: dayNum,
        isClaimed: dayNum < (state.bonusState?.settings?.returnBonus.loginsCount ?? 0),
        isCurrent: dayNum === state.bonusState?.settings?.returnBonus.loginsCount,
        percent: state.bonusState?.settings?.returnBonus.percents[dayNum - 1]
      })
    }
    items.push(dayItems)
  }

  return items
})


const totalBonus = computed(() => {
  return state.bonusState?.settings?.totalBonus
})

const wheelBonus = computed(() => {
  return state.bonusState?.settings?.wheelBonus
})

const returnBonus = computed(() => {
  return state.bonusState?.settings?.returnBonus
})

const playBonus = computed(() => {
  return state.bonusState?.settings?.playBonus
})

const purchaseBonus = computed(() => {
  return state.bonusState?.settings?.purchaseBonus
})

const currentDay = computed((): DayDTO|null => {
  for (const days of rows.value) {
    for (const day of days) {
      if (!day.isCurrent) {
        continue;
      }

      return day;
    }
  }

  return null;
})

const popup = ref<InstanceType<typeof PopupWrapper> | null>(null)
const canvasRef = ref<InstanceType<typeof HTMLCanvasElement> | null>(null)
const wheelSectionRef = ref<HTMLElement | null>(null)
const collectBtnRef = ref<HTMLElement | null>(null)
const prizes = computed(() => {
  if (!state.bonusState?.settings) {
    return []
  }
  return state.bonusState?.settings?.wheelBonus.sums.map((item: any) => {
    return numberFormatter.formatNumber(item[1].amount)
  })
})

const winIndex = computed<number>((): number => {
  if (!state.bonusState?.settings) {
    return 0
  }

  for (const i in state.bonusState?.settings?.wheelBonus.sums) {
    const item = state.bonusState?.settings?.wheelBonus.sums[i] as any
    if (item[0] === state.bonusState?.settings?.wheelBonus.index) {
      return i as unknown as number;
    }
  }

  return 0;
})


const drawWheel = (canvas: HTMLCanvasElement, angle: any) => {
  if (!canvas) {
    return
  }

  const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
  const numSectors = prizes.value.length;
  const arcSize = (2 * Math.PI) / numSectors;
  const cx = canvas.width / 2;
  const cy = canvas.height / 2;
  const radius = cx - 10;
  ctx.clearRect(0, 0, canvas.width, canvas.height);

  const fill2 = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
  fill2.addColorStop(0, '#373649');
  fill2.addColorStop(1, '#1b1a23');

  // Внешнее золотое кольцо
  ctx.beginPath();
  ctx.arc(cx, cy, radius, 0, 2 * Math.PI);
  ctx.fillStyle = fill2
  //ctx.fillStyle = '#292836';
  ctx.fill();


  ctx.beginPath();
  ctx.arc(cx, cy, radius - 15, 0, 2 * Math.PI);
  ctx.strokeStyle = '#525a7c';
  ctx.lineWidth = 3;
  ctx.stroke();

  // Секторы
  for (let i = 0; i < numSectors; i++) {
    const startAngle = angle + i * arcSize;
    const endAngle = startAngle + arcSize;
    const prize = prizes.value[i];

    ctx.beginPath();
    ctx.moveTo(cx, cy);
    ctx.arc(cx, cy, radius - 20, startAngle, endAngle);
    ctx.closePath();
    ctx.fillStyle = i % 2 === 0 ? '#5995ed' : '#ff3366';
    ctx.fill();

    ctx.beginPath();
    ctx.moveTo(cx, cy);
    ctx.arc(cx, cy, radius - 20, startAngle, endAngle);
    ctx.closePath();

    // Текст
    ctx.save();
    ctx.translate(cx, cy);
    ctx.rotate(startAngle + arcSize / 2);
    ctx.textAlign = 'right';
    ctx.font = '700 22px "Space Grotesk"';
    ctx.fillStyle = '#ffffff'
    //ctx.fillStyle = i % 2 === 0 ? '#5995ed' : '#ff3366';
    ctx.fillText(prize as string, radius - 35, 5);
    ctx.restore();
  }

  const fill = ctx.createRadialGradient(cx, cy, radius - 20, cx, cy, 0);
  fill.addColorStop(0, 'rgba(0,0,0,0.7)');
  fill.addColorStop(0.03, 'rgba(0,0,0,0)');
  fill.addColorStop(1, 'rgba(0,0,0,0)');
  ctx.beginPath();
  ctx.arc(cx, cy, radius - 20, 0, 2 * Math.PI);
  ctx.fillStyle = fill
  ctx.fill();

  // Лампочки
  const diff = 7;
  const lampCount = prizes.value.length * 2;
  for (let i = 0; i < lampCount; i++) {
    if (i % 2 !== 0) {
      continue;
    }
    const a = (i / lampCount) * 2 * Math.PI;

    const lx = cx + (radius - diff) * Math.cos(a);
    const ly = cy + (radius - diff) * Math.sin(a);
    ctx.beginPath();
    ctx.arc(lx, ly, 4, 0, 2 * Math.PI);
    ctx.fillStyle = '#FFC857';
    ctx.fill();
  }


  // Центральное тёмное кольцо
  ctx.beginPath();
  ctx.arc(cx, cy, 30, 0, 2 * Math.PI);
  ctx.fillStyle = '#0d1520';
  ctx.fill();
  ctx.strokeStyle = '#333';
  ctx.lineWidth = 4;
  ctx.stroke();
}


let idleRafId: number | null = null

const startIdleSpin = () => {
  const speed = 0.003 // радиан за кадр — медленно
  const tick = () => {
    if (state.spinning) return // уступаем реальному спину
    state.currentAngle += speed
    drawWheel(canvasRef.value!, state.currentAngle)
    idleRafId = requestAnimationFrame(tick)
  }
  idleRafId = requestAnimationFrame(tick)
}

const stopIdleSpin = () => {
  if (idleRafId !== null) {
    cancelAnimationFrame(idleRafId)
    idleRafId = null
  }
}

watch(() => canvasRef.value, (newValue) => {
  if (newValue) {
    drawWheel(newValue, state.currentAngle)
    startIdleSpin()
  }
})

const store = useStore()
const claim = () => {
  api.call.bonuses.dailyClaim().then(async () => {
    await store.dispatch('updateUser');
  })
  hide()
}

const showReel = () => {
  state.step = 1
  wheelSectionRef.value?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  spin()
}

const spin = () => {
  if (state.spinning) return;
  state.spinning = true;
  stopIdleSpin()


  const arcSize = (2 * Math.PI) / prizes.value.length;

  const targetSectorAngle = -Math.PI / 2 - (winIndex.value * arcSize + arcSize / 2);
  const normalizedCurrent = state.currentAngle % (2 * Math.PI);
  let angleDiff = targetSectorAngle - normalizedCurrent;

  const extraSpins = 5 + Math.floor(Math.random() * 5);
  const targetAngle = state.currentAngle + (angleDiff % (2 * Math.PI)) + extraSpins * 2 * Math.PI;

  const duration = 4000;
  const startTime = performance.now();
  const startAngle = state.currentAngle;

  function easeInOut(t: number) {
    return t < 0.5
      ? 4 * t * t * t
      : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function animate(now: any) {
    const elapsed = now - startTime;
    const t = Math.min(elapsed / duration, 1);
    state.currentAngle = startAngle + (targetAngle - startAngle) * easeInOut(t);
    drawWheel(canvasRef.value!, state.currentAngle);

    if (t < 1) {
      requestAnimationFrame(animate);
    } else {
      state.spinning = false;
      state.step = 2
      nextTick(() => {
        collectBtnRef.value?.scrollIntoView({ behavior: 'smooth', block: 'end' })
      })
    }
  }

  requestAnimationFrame(animate);
}

</script>